export { setProviderIcons, getProviderIcon } from './providers';
export { setCategoriesIcons, getCategoryIcon } from './categories';
